import { createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import i18n from 'i18next';

import { apiReducerBuilder } from 'utils';
import { RequestStatus } from 'utils/constants';

import { IWithdrawalRequest, RequestStatusTypes } from 'models';

import {
	approveWithdrawalRequest,
	getDeposit,
	getWithdrawals,
	sendWithdrawalRequest,
} from './actions';

interface Funding {
	deposit: any;
	withdrawals: { data: IWithdrawalRequest[] };
	status: RequestStatusTypes;
}

const fundingSlice = createSlice({
	name: 'settings',
	initialState: { deposit: {}, withdrawals: {} } as Funding,
	reducers: {},
	extraReducers: (builder) => {
		apiReducerBuilder(builder, getDeposit, (state, action) => {
			const { payload, meta } = action;
			state.status = meta.requestStatus;
			state.deposit = payload;
		});

		apiReducerBuilder(builder, getWithdrawals, (state, action) => {
			const { payload, meta } = action;
			state.status = meta.requestStatus;
			state.withdrawals = payload;
		});

		builder.addCase(sendWithdrawalRequest.rejected, (state, action) => {
			state.status = RequestStatus.FULFILLED;
		});

		builder.addCase(sendWithdrawalRequest.pending, (state, action) => {
			const { meta } = action;
			state.status = meta.requestStatus;
		});

		builder.addCase(sendWithdrawalRequest.fulfilled, (state, action) => {
			const { meta } = action;
			state.status = meta.requestStatus;
		});

		builder.addCase(approveWithdrawalRequest.fulfilled, (state, action) => {
			const { payload, meta } = action;
			state.status = meta.requestStatus;
			state.withdrawals = payload;

			message.success(i18n.t('successWithdrawalSendText') as string);
		});
	},
});

export default fundingSlice.reducer;
